import { QueryClient, QueryClientProvider } from "@tanstack/react-query";
import { ThemeProvider } from "next-themes";
import { type ReactNode, useState } from "react";
import { ToastProvider } from "../components/toast";
import { TooltipProvider } from "../components/ui/tooltip";
import { AuthProvider } from "../features/access/auth-context";

export function AppProviders({ children }: { children: ReactNode }) {
  const [queryClient] = useState(createAdminQueryClient);
  return (
    <ThemeProvider attribute="class" defaultTheme="system" enableColorScheme={false} enableSystem>
      <QueryClientProvider client={queryClient}>
        <AuthProvider>
          <TooltipProvider delayDuration={250}>
            <ToastProvider>{children}</ToastProvider>
          </TooltipProvider>
        </AuthProvider>
      </QueryClientProvider>
    </ThemeProvider>
  );
}

export function createAdminQueryClient(): QueryClient {
  return new QueryClient({
    defaultOptions: {
      mutations: { retry: false },
      queries: {
        gcTime: 30 * 60_000,
        refetchOnMount: true,
        refetchOnWindowFocus: false,
        retry: 1,
        staleTime: 2 * 60_000,
      },
    },
  });
}
